<template>
    <transition name="modal custom-modal">
        <div class="modal-mask modal-lg">
            <div class="modal-wrapper">
                <div class="modal-container">
                    
                    <div class="modal-header">
                        <button type="button" class="close" @click="$emit('close')">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                        <h3 style="width: initial;"><i class="fa fa-lg fa-info-circle"></i> Policy #{{ policy.policy_number }} <small>[{{ policy.id  }}]</small></h3>
                    </div>
                    
                    <div class="modal-body pre-scrollable" v-bind:style="{'max-height': bodyHeight + 'px'}">
                        <div class="lead-detail">
                            <div class="panel-body">
                                <div class="row">
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>Details</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Type</th><td>{{ policy.policy_type_code }}</td></tr>
                                                    <tr><th>Description</th><td>{{ policy.description }}</td></tr>
                                                    <tr><th>Effective Date</th><td>{{ policy.effective_date | formatDate }}</td></tr>
                                                    <tr><th>Expiration Date</th><td>{{ policy.expiration_date | formatDate }}</td></tr>
                                                    <tr><th>Client</th><td>({{ policy.client.client_id }}) [{{ policy.client.client_lookup_code }}] {{ policy.client.account_name }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>                              
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>IDs</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Policy Number</th><td>{{ policy.policy_number }}</td></tr>
                                                    <tr><th>Policy ID</th><td>{{ policy.policy_id }}</td></tr>
                                                    <tr><th>Original Policy ID</th><td>{{ policy.original_policy_id }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                
                                
                                <div class="row">
                                    <div class="col-xs-12 bg-dark lead-data">
                                        <h4>Branch & Source</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Branch</th><td><span class="label">{{ policy.branch_code.code }}</span> {{ policy.branch_code.description  }}</td></tr>
                                                    <tr><th>Source</th><td>{{ policy.source }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>Premiums</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Billed</th><td>${{ policy.billed_premium  }}</td></tr>
                                                    <tr><th>Estimated</th><td>${{ policy.estimated_premium  }}</td></tr>
                                                    <tr><th>Annualized</th><td>${{ policy.annualized_premium }}</td></tr>
                                                    <tr><th>Downloaded</th><td>${{ policy.downloaded }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 bg-dark lead-data">
                                        <h4>Commissions</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <table class="table">
                                                <tbody>
                                                    <tr><th>Billed</th><td>${{ policy.billed_commission  }}</td></tr>
                                                    <tr><th>Estimated</th><td>${{ policy.estimated_commission }}</td></tr>
                                                    <tr><th>Annualized</th><td>${{ policy.annualized_commission }}</td></tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-xs-12 bg-dark lead-data">
                                        <h4>Lines</h4>
                                        <div class="col-xs-12 fields-list-wrapper">
                                            <div class="table-responsive">
                                                <table class="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Line ID</th>
                                                            <th>Timestamp</th>
                                                            <th>Type Code</th>
                                                            <th>Description</th>
                                                            <th>Status</th>
                                                            <th>Issuing Company</th>
                                                            <th>Billed Premium</th>
                                                            <th>Estimated Premium</th>
                                                            <th>Annualized Premium</th>
                                                            <th>Downloaded Premium</th>
                                                            <th>Billed Commission</th>
                                                            <th>Estimated Commission</th>
                                                            <th>Annualized Commission</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="line in policy.lines">
                                                            <td>{{ line.line_id }}</td>
                                                            <td>{{ line.timestamp | formatTimestamp }}</td>
                                                            <td>{{ line.line_type_code }}</td>
                                                            <td>{{ line.line_type_description }}</td>
                                                            <td>{{ line.status_code }}</td>
                                                            <td>{{ line.issuing_company_lookup_code }}</td>
                                                            <td>${{ line.billed_premium }}</td>
                                                            <td>${{ line.estimated_premium }}</td>
                                                            <td>${{ line.annualized_premium }}</td>
                                                            <td>${{ line.downloaded_premium }}</td>
                                                            <td>${{ line.billed_commission }}</td>
                                                            <td>${{ line.estimated_commission }}</td>
                                                            <td>${{ line.annualized_commission }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                     
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>

export default {
  name: 'PolicyModal',
  props: {
    policy: {
      type: Object
    }
  },
  data: function () {
    return {
    };
  },
computed: {
   bodyHeight () {
     return $(window).height() - 200;
   }
  },

  methods: {

  }
}
</script>
<style scoped>
 .panel-body div.lead-data {
     padding:10px;
 }
  .panel-body div.lead-data + div {
  margin-top: 0px!important;
  }

 .panel-body .row {
     background-color: #f7f7f7;
 }
 .modal-header h3 {
  text-transform: unset!important;
  }

  .lead-detail .panel-body h4 button {
  right: 20px;
  top: 10px;
  position: absolute;
  }
  
  .lead-detail .panel-body > div {
  padding: 10px 20px;
  }

  .lead-detail .panel-body > div.fields-list-wrapper {
  padding: 0px;
  }
  
  .lead-detail h4 {
  padding-bottom: 10px;
  }
  
  .bg-dark {
  background-color: #f7f7f7;
  border-radius: 4px 4px;
  }
  ul.contact-info li i {
  color: #aaa;
  }
  ul.contact-info > li:not(:first-child)::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #dadada;
  width: .75em;
  margin-left: 20px;
  margin-right: 20px;
  }
  ul.contact-info li {
  display: inline-block;
  }

  .score-model-name {
  font-weight: 700;
  }
  .score-model-date {
  font-weight: 700;
  }
  .score-value {
  font-weight: 700;
  font-size: 2.75em;
  color: #ff4d50;
  text-align: right;
  padding-left: 30px;
  min-width: 50%;
  }

  .fields-list-wrapper > div {
  padding: 10px 20px;
  }
  
  .fields-list-wrapper > div.lead-fields {
  margin-right: 10px;
  }
  
  .fields-list-wrapper div.crm-fields {
  margin-left: 10px;
  }

  .lead-detail table {
  border-radius: 4px;
  }
  
  .lead-detail .table > tbody > tr > td {
  padding: 10px 10px;
  }
  
  .lead-detail th {
  background-color: initial;
  color: initial;
  }

  .service-title {
    text-transform: uppercase;
  }

  .lead-data table {
    overflow-x: auto;
  }

</style>



// WEBPACK FOOTER //
// PolicyModal.vue?3033577e